export { EloUploadSimpleIcon } from './upload-simple-icon'
